import "./App.css";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import ReactRouter from "./Config/Router";

function App() {
  return (
    <>
      <ReactRouter />
    </>
  );
}

export default App;
